import { arrayOf, string } from 'prop-types';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import {
  Button,
  PopoverBody,
  PopoverHeader,
  UncontrolledPopover,
} from 'reactstrap';

import ActiveView from '../../associations/Association/ActiveView';
import HELP_TEXTS from '../../campaigns/help-texts';
import { getTooltipButtonWithText } from '../../generic/Tooltip';
import api from '../../REST/api';
import { flash, tapFlashError, tapFlashSuccess } from '../../utils/flash';
import { salesChannelsEnum } from '../constants';
import OpsOnsiteHandover from './OpsOnsiteHandover';

const ButtonWithTooltip = getTooltipButtonWithText(HELP_TEXTS);

export default function HandoverButton({ selectedItems, itemsType }) {
  const [newOwnerId, setNewOwnerId] = useState('');
  const [newPc1Id, setNewPc1Id] = useState('');
  const [newSalesUnit, setNewSalesUnit] = useState('');
  const [newSalesTeam, setNewSalesTeam] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const hasNoSelectedItems = selectedItems.length === 0;
  const isSaveBtnDisabled = !newOwnerId || isSaving;
  const history = useHistory();
  const isCampaignType = itemsType === 'campaigns';

  const itemsName = opportunity =>
    itemsType === 'opportunities'
      ? opportunity.name
      : opportunity.campaign.name;

  const onChange = e => {
    api.getUser({ id: e.target.value }).then(newOwner => {
      setNewOwnerId(e.target.value);
      setNewPc1Id(newOwner.id);
      setNewSalesUnit(newOwner.salesUnit);
      setNewSalesTeam(newOwner.salesTeam);
    });
  };

  const onSubmit = async () => {
    setIsSaving(true);
    flash(`Saving the selected ${itemsType}...`, 'info');
    try {
      await Promise.all(
        selectedItems.map(async opportunityId => {
          const id = Number.parseInt(opportunityId, 10);
          const opportunity = await api.getOpportunity({
            id,
            search: { _fields: 'campaign,name,salesChannel' },
          });
          const isSelfService =
            opportunity.salesChannel === salesChannelsEnum.SELF_SERVICE;
          const isManaged =
            opportunity.salesChannel === salesChannelsEnum.MANAGED;

          const dynamicPayload = () => {
            if (isSelfService)
              return {
                ownerId: newOwnerId,
                pc1Id: newPc1Id,
                salesUnit: newSalesUnit,
                salesTeam: newSalesTeam,
              };
            if (isManaged)
              return {
                ownerId: newOwnerId,
                salesUnit: newSalesUnit,
                salesTeam: newSalesTeam,
              };
            return {
              ownerId: newOwnerId,
            };
          };

          return api
            .patchOpportunity({ id, data: dynamicPayload() })
            .catch(tapFlashError())
            .catch(() => {
              tapFlashError()(
                new Error(
                  `There was a problem while trying to change the owner of ${itemsName(
                    opportunity,
                  )}`,
                ),
              );
            });
        }),
      );
      tapFlashSuccess(`All ${itemsType} saved successfully`)();
      // setTimeout allows the user to know changes were successfull by letting the success flash message appears before the page is refreshed.
      setTimeout(() => {
        history.go();
      }, '1000');
      // eslint-disable-next-line no-empty
    } catch (e) {
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <ButtonWithTooltip
        className="btn-handover"
        id="popover"
        type="button"
        helpKey="handover"
        section="actionButtons"
        color="secondary"
        disabled={hasNoSelectedItems}
        showTooltip={hasNoSelectedItems}
      >
        Handover
      </ButtonWithTooltip>

      <UncontrolledPopover
        className="handover-popover"
        placement="left"
        target="popover"
        trigger="legacy"
      >
        <PopoverHeader>Handover campaigns to...</PopoverHeader>
        <PopoverBody className="popover-body">
          <div className="d-flex align-items-center">
            <div className="col-md-2">Owner</div>
            <div className="col-md-8">
              <ActiveView
                isMulti={false}
                onSelectBlur={() => {}}
                name="newOwner"
                value={newOwnerId}
                type="user"
                onChange={onChange}
              />
            </div>
            <div className="col-md-2">
              <Button
                className="save"
                onClick={onSubmit}
                disabled={isSaveBtnDisabled}
              >
                Save
              </Button>
            </div>
          </div>
          {isCampaignType && (
            <div className="d-flex align-items-center mt-3">
              <OpsOnsiteHandover
                selectedItems={selectedItems}
                itemsType={itemsType}
              />
            </div>
          )}
        </PopoverBody>
      </UncontrolledPopover>
    </>
  );
}

HandoverButton.propTypes = {
  selectedItems: arrayOf(string.isRequired).isRequired,
  itemsType: string.isRequired,
};
